<template>
  <v-dialog v-model="dialog" width="400px">
    <v-card>
      <v-card-title class="headline">
        <v-icon>warning</v-icon> Advertencia
      </v-card-title>
      <v-card-text class="py-0">
        <h3>¿Desea anular el permiso?</h3>
        <h4>Nota: Esta acción es irreversible</h4>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" @click.prevent="close()">
          Cancelar
        </v-btn>
        <v-btn
          color="success"
          @click.prevent="anularControlPermiso()"
          :loading="loading"
        >
          Anular
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["item"],
  data() {
    return {
      dialog: false,
      permiso: {},
      loading: false,
      id: null
    };
  },
  mounted() {
    this.$bus.$on("openDialogAnularPermisoAnularPapeletaVacacion", item => {

      this.id = item;
      this.permiso = item.permiso;
      this.dialog = true;
    });
  },
  methods: {
    close() {
      this.dialog = false;
      this.permiso = {};
      this.loading = false;
      this.$bus.$emit("closeDialogAnularPapeletaVacacion");
    },
    async anularControlPermiso() {
      this.loading = true;
      let user = this.$storage.get("user");
      let id_persona = user.id_persona;
      if (id_persona != "") {
        try {
          let respuesta = await this.$service.graphql({
            query: `
				query{
					runQuery(consulta:"select control.fn_aprueba_permiso_rrhh(${this.id},${id_persona},9,${user.id})"){
					respuesta
					}
				}
				`
          });
          let resp = respuesta.runQuery.respuesta[0].fn_aprueba_permiso_rrhh;

          let resps = resp.split("|");
          let correcto = resps[0];
          console.log(correcto);
          if (correcto === "1") {
            this.$confirm("El permiso fué anulado", () => {});
            this.$bus.$emit("closeDialog");
             this.close();
          } else {
           this.$confirm(resps[1], () => {}); 
           this.close()
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        try {
          let respuesta = await this.$service.graphql({
            query: `
				query{
					runQuery(consulta:"select control.fn_solicita_anula_permiso(${this.id},9,${id_persona},${user.id},'')"){
					respuesta
					}
				}
				`
          });

          let resp = respuesta.runQuery.respuesta[0].fn_solicita_anula_permiso;

          let resps = resp.split("|");
          let correcto = resps[0];
          console.log(correcto);
          if (correcto === "1") {
            this.$message.success();
            //this.$router.push('/personas')
          } else {
            this.$message.error(resps);
            // this.close()
          }
        } catch (error) {
          console.log(error);
        }
      }
      this.close();
      this.loading = false;
    },
    getUserId() {
      const user = this.$storage.get("user");
      return user.id;
    },
    async registerSeguimientoDetalle(id_permiso, id_persona, id_estado) {
      //console.log('gg'+this.id+'ttt'+id_persona+'fgdfgfdg'+id_estado)
      let seguimiento_detalle = {
        id_permiso,
        id_persona,
        id_estado
      };

      await this.$service.graphql({
        query: `
					mutation add($seguimientoDetalle: NewSeguimientoDetalle!) {
						seguimientoDetalleAdd(seguimientoDetalle: $seguimientoDetalle) {
							id
						}
					}
				`,
        variables: {
          seguimientoDetalle: seguimiento_detalle
        }
      });
      console.log("Seguimiento registrado");
      //location.reload()
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/admin/papeleta_vacacion/dialogs/AnularPermiso.vue